import React from 'react';
import Table from 'components/shared/table';

const ArchivesActivityCell = ({ activityCount }) => (
  <Table.BodyCell size="s" hideBelowMD center>
    {activityCount || '0'}
  </Table.BodyCell>
);

export default ArchivesActivityCell;
